import { Contract } from "@ethersproject/contracts"
import { BigNumber } from "bignumber.js"
import { DEFAULT_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from "config"
import { BIG_TEN } from "utils/bigNumber"
import getGasPrice from "utils/getGasPrice"
import { estimateGas } from "./estimateGas"

const DEFAULT_GAS_LIMIT_DEPOSIT = 350000
const execute = async (cl: Contract, methodName: string, args: any[], defaultGas?: any) => {
  const gasPrice = getGasPrice()
  const estimatedGasLimit = defaultGas ?? await estimateGas(cl, methodName, args, 1000)
  const tx = await cl[methodName](...args, { gasPrice, gasLimit: estimatedGasLimit })
  const receipt = await tx.wait()
  return {
    ...receipt,
    hash: receipt.transactionHash
  }
}

export const depositCL = async (cl, lpAddress, amount) => {
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()
  return execute(cl, "deposit", [lpAddress, value], DEFAULT_GAS_LIMIT_DEPOSIT)
}

export const withdrawCL = async (cl, lpAddress, amount) => {
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()
  return execute(cl, "withdraw", [lpAddress, value])
}

export const addRule = async (cl, lpAddress, token0Amount, decimals0, token1Amount, decimals1, deadline) => {
  const token0Value = new BigNumber(token0Amount).times(BIG_TEN.pow(decimals0)).toString()
  const token1Value = new BigNumber(token1Amount).times(BIG_TEN.pow(decimals1)).toString()
  return execute(cl, "addRule", [lpAddress, token0Value, token1Value, deadline], DEFAULT_GAS_LIMIT)
}